import React from "react";
import "./ProfessorModal.css";

const ProfessorModal = ({ professor, onClose }) => {
  if (!professor) return null;

  return (
    <div className="modal professor-modal">
      <div className="modal-content">
        <h3>Detalhes do Professor</h3>
        <p><strong>Nome:</strong> {professor.Nome}</p>
          <p><strong>Número BI:</strong> {professor.NumeroBI}</p>
          <p><strong>Nível Acadêmico:</strong> {professor.NivelAcademico}</p>
          <p><strong>Telefone:</strong> {professor.Telefone}</p>
          <p><strong>Email:</strong> {professor.Email}</p>
          <p><strong>Gênero:</strong> {professor.Genero}</p>
          <p><strong>Disciplinas:</strong> {(professor.Disciplinas || []).join(", ")}</p>
          <p><strong>Classes:</strong> {(professor.Classes || []).join(", ")}</p>
          <p><strong>Experiência:</strong> {professor.Experiencia}</p>
        <button onClick={onClose}>Fechar</button>
      </div>
    </div>
  );
};

export default ProfessorModal;
